import {useContext} from 'react'
import { Link } from 'react-router-dom'
import SearchHeader from '../SearchHeader/SearchHeader'
import './Header.css'
import LanguageSelector from '../LanguageSelector/LanguageSelector'
import { LanguageContext } from '../../context';
import Navigation from '../Navigation/Navigation'

const Header = () => {

    const { language } = useContext(LanguageContext);
    var config = require('../../config.json');
   

  return (
    <>
        <div className='header-top'>
            <nav className='right-section' aria-label="קישורים">
                <Navigation/>
            <Link  to={{pathname:`/${language}`}}>
                <div className='header-title'>TLV OpenData</div>
                </Link>
            </nav>
           
            <nav className='logo-section' aria-label="לאתר העירייה">
                 <div className="logoBackGround"></div>
                <a  className='logo' href={`${config.TlvWeb}/${language=="en"?language:""}`} target='_blank'>
                    <div className='logo-header'></div>
                    <div className="sr-only">לאתר עיריית תל אביב</div>
                </a>
            </nav>
            <nav className='left-section' aria-label="תפריט חיפוש ושפות">
                <div className="search" aria-label="חיפוש"><SearchHeader/></div>          
                <div className="language"><LanguageSelector/></div>
                
            </nav>
        </div>
        <div className='border'></div>
    </>
  )
}

export default Header